<script lang="ts">
    import {onMount} from 'svelte';
    import {Button, Divider, FileDropzone, FormField, SnackbarContainer, TextField} from 'attractions';
    import {CopyIcon, RefreshCwIcon} from 'svelte-feather-icons';
    import {Hasher} from '../lib/Hasher';
    import Clipboard from "../lib/Clipboard";
    import {
        createAdler32,
        createBLAKE2b,
        createBLAKE2s,
        createBLAKE3,
        createCRC32,
        createKeccak,
        createMD4,
        createMD5,
        createRIPEMD160,
        createSHA1,
        createSHA224,
        createSHA256,
        createSHA3,
        createSHA384,
        createSHA512,
        createSM3,
        createWhirlpool, createXXHash128, createXXHash3,
        createXXHash32,
        createXXHash64,
    } from 'hash-wasm';

    const hasher = new Hasher();
    let hashes = [];

    onMount(async () => {
        hashes = await buildHashes();
    });


    let inputValue = "";
    let inputFile = null;

    let output = "";

    let forceShowProgressForId = -1;

    async function buildHashes() {
        return [
            {label: "MD5", hash: await createMD5(), value: "", progress:0},
            {label: "SHA-1", hash: await createSHA1(), value: "", progress:0},
            {label: "SHA-2 (256)", hash: await createSHA256(), value: "", progress:0},
            {label: "SHA-2 (512)", hash: await createSHA512(), value: "", progress:0},
            {label: "SHA3", hash: await createSHA3(512), value: "", progress:0},
            {label: "CRC32", hash: await createCRC32(), value: "", progress:0},
            {label: "Blake3", hash: await createBLAKE3(), value: "", progress:0},

            {label: "Adler32", hash: await createAdler32(), value: "", progress:0},
            {label: "Blake2b", hash: await createBLAKE2b(), value: "", progress:0},
            {label: "Blake2s", hash: await createBLAKE2s(), value: "", progress:0},
            {label: "MD4", hash: await createMD4(), value: "", progress:0},
            {label: "RIPEMD160", hash: await createRIPEMD160(), value: "", progress:0},
            {label: "SHA-2 (224)", hash: await createSHA224(), value: "", progress:0},
            {label: "SHA-2 (384)", hash: await createSHA384(), value: "", progress:0},
            {label: "SHA3 (224)", hash: await createSHA3(224), value: "", progress:0},
            {label: "SHA3 (256)", hash: await createSHA3(256), value: "", progress:0},
            {label: "SHA3 (384)", hash: await createSHA3(384), value: "", progress:0},
            {label: "Keccak-224", hash: await createKeccak(224), value: "", progress:0},
            {label: "Keccak-256", hash: await createKeccak(256), value: "", progress:0},
            {label: "Keccak-384", hash: await createKeccak(384), value: "", progress:0},
            {label: "Keccak-512", hash: await createKeccak(512), value: "", progress:0},
            {label: "SM3", hash: await createSM3(), value: "", progress:0},
            {label: "Whirlpool", hash: await createWhirlpool(), value: "", progress:0},
            {label: "xxHash32", hash: await createXXHash32(), value: "", progress:0},
            {label: "xxHash64", hash: await createXXHash64(), value: "", progress:0},
            {label: "xxHash3", hash: await createXXHash3(), value: "", progress:0},
            {label: "xxHash128", hash: await createXXHash128(), value: "", progress:0},

        ];
    }

    async function buildHash(hash, id) {
        if (inputFile !== null) {
            forceShowProgressForId = id;
            return await hasher.hashFile(hash.hash, inputFile, 0, (progress, total) => {
                hash.progress = Math.ceil(progress/total * 100);
                hashes = hashes;
                if(forceShowProgressForId === id && hash.progress > 0) {
                    forceShowProgressForId = -1;
                }
            });
        }
        return hasher.hashText(hash.hash, inputValue);
    }

    function resetHashValues(value, file) {
        inputValue = value;
        inputFile = file;

        hashes.forEach(v => v.value = "");
        // redundant assignment because we are watching an array of objects
        hashes = hashes;
    }

    async function valueUpdated(e) {
        resetHashValues(e.detail.value, null);
    }

    async function fileUpdated(e) {
        if (e.detail && e.detail.files && e.detail.files[0]) {
            resetHashValues("", e.detail.files[0]);
        } else {
            resetHashValues("", null);
        }
    }


</script>
<h2>Generate hash</h2>
<SnackbarContainer let:showSnackbar>
    <form>
        <Divider text="Input"/>
        <FormField name="Input" help="Paste your text here">
            <TextField multiline bind:value={inputValue} on:input="{valueUpdated}"/>
        </FormField>
        <FormField name="Input file" help="Drop or open a file (no upload, everything happens locally)">
            <FileDropzone max="1" on:change={fileUpdated}/>
        </FormField>
        <Divider text="Results"/>
        {#each hashes as hash,i}
            <div class="text-field-shrunk text-field-shrunk--outline">
                <TextField outline label={hash.label} readonly bind:value={hashes[i].value}/>
                {#if forceShowProgressForId === i || (hashes[i].progress > 0 && hashes[i].progress < 100)}
                    <progress max="100" value="{hashes[i].progress}"></progress>
                {/if}

                <Button filled on:click={async () =>{hashes[i].value = await buildHash(hashes[i], i)}}>
                    <RefreshCwIcon size="20" class="mr"/>
                </Button>
                <Button filled on:click={() =>{ Clipboard.copyTextToClipboard(hashes[i].value); showSnackbar({ props: { text: `copied ${hashes[i].value.length} chars to clipboard.`  } })}}>
                    <CopyIcon size="20" class="mr"/>
                </Button>

            </div>
        {/each}
    </form>
</SnackbarContainer>
